import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class PdfDownloadService {
  generateAndDownloadPDF(element: HTMLElement): Promise<void> {
    return html2canvas(element, {
      scale: 2,
      logging: false,
      useCORS: true,
    }).then((canvas) => {
      const pdf = new jsPDF('p', 'mm', 'a4');

      // Define page margins (in mm)
      const margin = 15;

      // A4 dimensions with margins
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = pageWidth - 2 * margin;
      const contentHeight = pageHeight - 2 * margin;

      // Calculate image dimensions
      const imgWidth = contentWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Calculate number of pages needed
      const pageCount = Math.ceil(imgHeight / contentHeight);

      // For each page, calculate the clipping and positioning
      for (let i = 0; i < pageCount; i++) {
        if (i > 0) {
          pdf.addPage();
        }

        // Calculate clipping for current page
        const sourceY = i * contentHeight * (canvas.width / imgWidth);
        const sourceHeight = Math.min(
          canvas.height - sourceY,
          contentHeight * (canvas.width / imgWidth),
        );

        // Create temporary canvas for the current page section
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = sourceHeight;

        // Copy portion of original canvas to temp
        const ctx = tempCanvas.getContext('2d');
        ctx?.drawImage(
          canvas,
          0,
          sourceY,
          canvas.width,
          sourceHeight,
          0,
          0,
          canvas.width,
          sourceHeight,
        );

        // Calculate height for this section
        const pageImgHeight = (sourceHeight * imgWidth) / canvas.width;

        // Add image with proper positioning
        pdf.addImage(
          tempCanvas.toDataURL('image/png'),
          'PNG',
          margin,
          margin,
          imgWidth,
          pageImgHeight,
          undefined,
          'FAST',
        );
      }

      pdf.save('record-details.pdf');
    });
  }
}
